
import React, { useState, useEffect, useRef } from "react";
// import Header from "../common/components/Header";
import { useLocation } from 'react-router-dom';
import Analysis from "../ReportandAnaysisManagment/Food/Analysis";
import Analysisfood from "../ReportandAnaysisManagment/Food/Analysisfood";
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Foodandbeveragesadvertise from './Foodandbeveragesadvertise';
// import "./NavBars"
// import Footer from "../common/components/Footer";
import './Foodandbeverags.css';
const Foodandreporanalysis = () => {


    const [categories, setCategories] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const location = useLocation();
    const isMobile = window.innerWidth <= 768;
    const [activeCategory, setActiveCategory] = useState("Overview");

    useEffect(() => {
        if (location.state?.activeCategory === 'Payments') {
            setActiveCategory('Payments');
        }
    }, [location]);

    useEffect(() => {
        if (location.state?.activeCategory === 'Profile') {
            setActiveCategory('Profile');
        }
    }, [location]);

    useEffect(() => {
        if (location.state?.activeCategory === 'Notifications') {
            setActiveCategory('Notifications');
        }
    }, [location]);
    // Function to handle card click and set the active category
    const handleClick = (category) => {
        setActiveCategory(category);
    };

    const navigate = useNavigate();


    // Automatically activate the first item from backend data
    useEffect(() => {
        if (categories.length > 0) {
            setActiveCategory("Allitems"); // Default to "Allitems"
        }
    }, [categories]);


    const scrollContainerRef = useRef(null);



    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        let interval;

        const startScrolling = () => {
            interval = setInterval(() => {
                if (!isHovered) {
                    scrollContainer.scrollTop += 1; // Scroll down smoothly

                    // Infinite loop logic
                    if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
                        scrollContainer.scrollTop = 0; // Reset to top for seamless loop
                    }
                }
            }, 20); // Adjust speed by changing interval
        };

        startScrolling();

        return () => clearInterval(interval);
    }, [isHovered]);






    return (
        <>
            <div className="container-fluid">

                <div className="row" style={{ marginTop: "40px" }}>

                    {/* Left Column - Scrollable Category List */}
                    <div className="col-lg-2 col-md-12 col-sm-12 col-12">
                        <div
                            style={{
                                maxHeight: "600px",
                                position: "fixed",
                                top: "50px",
                                marginTop: "5px",
                                zIndex: 1000,
                                width: "180px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",

                            }}
                        >

                            <div className="category-container" style={{
                                overflowY: "auto",
                                height: "540px",
                                marginTop: "68px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                            }}>
                                {/* Category Cards */}
                                {[].map(
                                    (category, index) => (
                                        <div
                                            key={index}
                                            className="category-card"
                                            onClick={() => handleClick(category)}
                                            style={{
                                                backgroundColor: activeCategory === category ? "rgb(177 93 198)" : "#D9D9D9",
                                                margin: "8px 0",
                                                padding: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                cursor: "pointer",
                                                justifyContent: "center",
                                                borderRadius: "15px",
                                                transition: "0.3s ease-in-out",
                                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                            }}
                                        >
                                            {/* Icon inside a fixed-size wrapper */}


                                            <div style={{ fontSize: "20px", fontWeight: "bold" }} className="category-card-body d-flex justify-content-center p-0">
                                                {category}
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>

                        </div>
                    </div>

                    {/* Right Column - Content Based on Active Category */}
                    <div className="col-lg-7 col-md-12 col-sm-12 col-12 cartdta-mobileee" style={{ paddingLeft: "10px", paddingRight: "0px" }}  >


                        <p
                            className="breadcrumb maamaas-home-bredcum"
                            style={{
                                position: "fixed",
                                top: window.innerWidth <= 425 ? " 50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "54px" : "64px" ,                            
                                left: "2vw",
                                width: "100%",
                                backgroundColor: "#fff",
                                zIndex: 1000,
                                padding: "10px 0",
                                fontSize: isMobile ? "16px" : "18px",
                                fontWeight: isMobile ? "normal" : "bold",
                                textAlign: "center",
                                margin: 0,
                            }}
                        >
                            {/* <Link
                                to="/Newmainlandingpage"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Home
                            </Link> */}

                            {/* <span className="separator"> &gt; </span> */}
                            <Link
                                to="/fooddashboard"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Food & Beverages
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link

                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Report Analysis
                            </Link>
                        </p>



                        <div
                            style={{

                                borderRadius: "8px",
                            }}
                            className="reports-data-analysis"
                        >
                            {/* Show different details based on active category */}
                            {activeCategory === "Overview" && (
                                <div>
                                    {/* <h3>Cart Details</h3> */}
                                    <Analysis />
                                </div>
                            )}
                            {activeCategory === "Food" && (
                                <div>
                                    {/* <h3>Profile</h3>*/}
                                    <Analysisfood />
                                </div>
                            )}



                        </div>
                    </div>
                </div>


                <div className="col-lg-3 col-md-12 col-sm-12 addhide">

                    <Foodandbeveragesadvertise />
                </div>
            </div>
            <style>
                {`
                @media (min-width: 769px) and (max-width:1000px) {
    .reports-data-analysis {
        margin-top: 100px !important;
    }
}
    @media(max-width:991px){
    .addhide{
    display:none;
    }
    }
                `}
            </style>
        </>
    );
};

export default Foodandreporanalysis;
